



















import { Component, Prop, Vue } from 'vue-property-decorator'
import loadingGif from '@/assets/img/loading.gif'
import { Button, Card } from '@alpha/ink'
import store from '@/store'
import { Location } from '@/components/Templates/TemplateManager.vue'

@Component({
  components: {
    Button,
    Card
  }
})
export default class Survey extends Vue {
  @Prop({ required: true }) location!: Location

  loading = true
  success = false
  lastLoadTime: number = 0
  loadingGif = loadingGif

  async created () {
    if (this.location === Location.DefaultDraftTestCreation) {
      this.loading = false
      this.success = true
    } else {
      await this.hydrateData()
    }
  }

  get isAlphaAdmin () {
    return store.state.user.authenticatedUser!.admin
  }

  get workspaceId () {
    return this.$route.params.workspaceId
  }

  get testId () {
    return this.$route.params.testId
  }

  async hydrateData () {
    const startLoading = Date.now()
    this.loading = true
    const { workspaceId, testId } = this
    const payload = { workspaceId, testId }
    const success = await store.dispatch.survey.fetchSurvey(payload)
    if (success) {
      await store.dispatch.surveyConfiguration.fetchTestConfigurations({ workspaceId, testId }).catch(console.error)
      this.success = true
    }
    this.loading = false
    const finishLoading = Date.now()
    this.lastLoadTime = finishLoading - startLoading
  }
}
